<template>
    <div class="kefutopbg">
        <div class="topleft">
            <a href="javascript:;" @click="return_index()">
                <div id="kefulogo"></div>
            </a>
        </div>
        <!-- <div class="kefutop1">
            <label style="font-size: 14px;color:rgb(157, 226, 247);">邮箱/门牌号/手机号：</label>
            <input type="text" class="kefuinput1" v-model="loginName"/>
        </div>
        <div class="kefutop2">
            <label style="font-size: 14px;color:rgb(157, 226, 247);">密码：</label>
            <input type="password" class="kefuinput1" style="width:100px;" v-model="loginPwd"/>
        </div>
        <div class="kefutop3">
            <label style="font-size: 14px;color:rgb(157, 226, 247);">验证码：</label>
            <input type="text" class="kefuinput1" style="width:60px;" v-model="code"/>
            <div @click="refreshCode()" style="float:right;">
                <s-identify :identifyCode="identifyCode"></s-identify>
            </div>
        </div>
        <div class="kefutop4">
            <input class="sure" type="button" value="登录" @click="login()">
        </div> -->
        <div class="topright">    
            <ul>
                <li><a href="javascript:;" @click="return_index()">首页</a></li>
                <li><a href="javascript:;" @click="res_user()">免费注册</a></li>
                <li><a href="feeindex" target="rightFrame">资费</a></li>
            </ul>
        </div>
    </div>
</template>
<style>
  .topbg{
      background:url(../../assets/images/topbg.gif) repeat-x;
      width: 100%;
      height: 88px;
  }
</style>
<script>
// import crypto from 'crypto'
import {setCookie,getCookie} from '../../assets/js/cookie.js'

export default {
    data(){
        return{
            identifyCodes: "1234567890",
            identifyCode: "",
            loginName: '',
            loginPwd: '',
            code: '',
        }
    },
    mounted() {
        this.identifyCode = "";
        this.makeCode(this.identifyCodes, 4);
    },
    methods:{
        // login(){
        //     var that = this;
        //     if(this.loginName == ""){
        //         alert("请输入账号")
        //         return
        //     }
        //     if(this.loginPwd == ""){
        //         alert("请输入密码")
        //         return
        //     }
        //     // if(this.code == ""){
        //     //     alert("请输入验证码")
        //     //     return
        //     // }
        //     var password = this.$options.methods.getmd5(this.$options.methods.getmd5(this.loginPwd)+this.loginName)
        //     let data = {'loginName':this.loginName,'loginPwd':password,'loginSource':'web'}
        //     this.$ajax({
        //         method: 'post',
        //         url: this.GLOBAL.serverSrc + '/login/login.json',
        //         data: data,
        //         headers: {
        //             'Content-Type': 'application/json; charset=UTF-8'
        //         }
        //     }).then(function(res) {
        //         console.log(JSON.stringify(res.data))
        //         if('0000000' == res.data.code)
        //         {
        //             that.GLOBAL.token = res.data.token;
        //             setCookie('2officesessionid',res.data.token,60*60*10);
        //             window.open('main');
        //             that.loginName = '';
        //             that.loginPwd = '';
        //             that.code = '';
        //             that.refreshCode();
        //         }
        //         else
        //         {
        //             alert(res.data.msg)
        //         }
        //     })
        // },
        // getmd5(str){
        //     var a;
        //     var md5 = crypto.createHash("md5");
        //     md5.update(str);
        //     var a = md5.digest('hex');
        //     return a;
        // },
        randomNum(min, max) {
            return Math.floor(Math.random() * (max - min) + min);
        },
        refreshCode() {
            this.identifyCode = "";
            this.makeCode(this.identifyCodes, 4);
        },
        makeCode(o, l) {
            for (let i = 0; i < l; i++) {
                this.identifyCode += this.identifyCodes[
                    this.randomNum(0, this.identifyCodes.length)
                ];
            }
        },
        return_index() {
            //返回首页
            window.open('/')
        },
        res_user() {
            //注册
            window.open('reg')
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/shouye/topindex.vue